import { useState } from "react";
import { useAppSelector } from "../../../redux";
import EmailInput from "../../InfoPage/EmailInput";
import { selectText } from "../../LanguageSelect/LanguageSelectSlice";
import { useEmail } from "./hooks";
import getStyles from "../styles";
import { Grid } from "@mui/material";
import { AcctionButtons } from "../AcctionButtons";

interface EmailModalProps {
  handleClose(): void;
}

export function EmailModal(props: EmailModalProps) {
  const { handleClose } = props;
  const text = useAppSelector(selectText);
  const styles = getStyles();

  const [error, setError] = useState<boolean>(false);

  const { updateEmail, email, handleEmailChange } = useEmail({
    error,
    setError,
    handleClose,
  });

  return (
    <>
      <EmailInput
        label={text.emailLabel}
        helperText={text.emailExample}
        email={email}
        error={error}
        styles={styles}
        handleEmailChange={handleEmailChange}
      />
      <Grid container>
        <AcctionButtons action={updateEmail} handleClose={handleClose} type="button" title={text.update} />
      </Grid>
    </>
  );
}
